import React, { useMemo, useState, useEffect, useReducer } from "react";
import { Edit } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import api from "../../../../_core/api";
import * as S from "../styles";
import { Button, Table, Modal } from "../../../../_core/_components";
import { handleErrors, success } from "../../../../_core/services/toast";
import { FullScreenLoading } from "../../../../_core/_components/fullscreen-loading";
import { INITIAL_STATE, reducer } from "./reducer";
import ModalContent from "./modal-content";

export const Canal: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [canalList, setCanalList] = useState<any[]>([]);
  const [form, dispatch] = useReducer(reducer, undefined);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.post(`/api/cartas/canal/buscar`, {
        nomeCanal: "",
      });
      setCanalList(data.content);
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const onClickSave = async () => {
    try {
      setIsLoading(true);
      await api.post(`/api/cartas/canal/salvar`, form);
      dispatch({ type: "UNSET_CANAL" });
      const { data } = await api.post(`/api/cartas/canal/buscar`, {
        nomeCanal: "",
      });
      setCanalList(data.content);
      success("Canal salvo com sucesso.");
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const data = useMemo(() => {
    return canalList.map((e) => ({
      ...e,
      ativoStr: e.flagAtivo ? "Sim" : "Não",
      editar: (
        <IconButton
          onClick={() =>
            dispatch({
              type: "SET_CANAL",
              payload: {
                ...e,
              },
            })
          }
        >
          <Edit />
        </IconButton>
      ),
    }));
  }, [canalList]);

  return (
    <>
      {form && (
        <Modal
          title="Adicionar / Alterar Canal"
          onClose={() => dispatch({ type: "UNSET_CANAL" })}
          content={<ModalContent form={form} dispatch={dispatch} />}
          actionItems={[<Button onClick={onClickSave} text="Salvar" />]}
        />
      )}
      <FullScreenLoading isEnabled={isLoading} />
      <S.DataContainer>
        <S.TopBar>
          <S.SearchBar></S.SearchBar>
          <Button
            text="Novo"
            onClick={() =>
              dispatch({ type: "SET_CANAL", payload: INITIAL_STATE })
            }
            styles={{ width: 100 }}
          />
        </S.TopBar>
        {canalList.length > 0 && (
          <Table
            columns={[
              { label: "Nome", key: "nomeCanal" },
              { label: "Ativo", key: "ativoStr" },
              { label: "Editar", key: "editar" },
            ]}
            data={data}
          />
        )}
      </S.DataContainer>
    </>
  );
};
